import { useContext } from "react";
import AuthContext from "./AuthDataProvider";

const useAuthContext = () => {
    return useContext(AuthContext);
}

export default useAuthContext;